import { useAPIGetKinerjaHarianActive } from 'api/kinerja/kinerja-harian-ps'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { useKinerjaTipe } from 'app/KinerjaShared/hooks/useKinerjaTipe'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import useToggleSdkContext from 'utils/useToogleSdk'

export function useKinerjaHarianPSActive() {
  const { periodYear, periodNo } = usePeriodContext()
  const { tipe } = useKinerjaTipe()
  const { isPegawaiPengawasSekolah } = useRoleContext()
  const toggle = useToggleSdkContext()

  const showKinerjaHarianEntryPoint =
    toggle?.['kinerja-harian-ps-enabled'] || false

  // Only allow access to Kinerja Harian for Pegawai Pengawas Sekolah
  const isAllowed = isPegawaiPengawasSekolah && showKinerjaHarianEntryPoint

  const { data, isLoading, isSuccess } = useAPIGetKinerjaHarianActive({
    params: {
      skpYear: periodYear,
      skpPeriod: periodNo,
      tipe,
    },
    options: {
      enabled:
        isAllowed && Number.isInteger(periodYear) && Number.isInteger(periodNo),
      useErrorBoundary: false,
    },
  })

  const isActive = isAllowed && data?.data?.active === true
  const isPerencanaanReady = data?.data?.perencanaanState === 'READY'

  return { isActive, isPerencanaanReady, isLoading, isSuccess }
}
